import { MaskCoreProps } from "./types"
import React from "react"
import styled from '~/ui/styled'
import { debug } from "~utils"
import { Flex } from "~components/El"

const InnerMask = styled(Flex)<Partial<MaskCoreProps>>`
  width: auto;
  height: auto;
  display: flex;
  position: absolute;
  justify-content: ${({ justifyContent }) => justifyContent || "center"};
  align-items: center;
  background-color: ${({ theme, backgroundColor }) => backgroundColor || theme.colors.mask};
`

export const MaskCore: React.FC<MaskCoreProps> = ({
  onClick = () => debug("MaskCore no onClick!"),
  backgroundColor,
  children,
  justifyContent,
}) => {
  return (
    <InnerMask onClick={onClick} backgroundColor={backgroundColor} justifyContent={justifyContent}>
      {children}
    </InnerMask>
  )
}
